import { Fragment } from 'react';

/**
 * The closing sentence, one span per word for the scrubbed reveal (words rendered by
 * React, not SplitText: no async split, no layout shift, real text). Non-breaking
 * spaces inside the copy stay inside their word.
 */
export function ClosingLine({ text, className = '' }: { text: string; className?: string }) {
	const words = text.split(' ');
	return (
		<p data-closing className={className}>
			{words.map((word, index) => (
				<Fragment key={`${index}-${word}`}>
					<span data-closing-word>{word}</span>
					{index < words.length - 1 && ' '}
				</Fragment>
			))}
		</p>
	);
}
